import { Str } from '@atabix/core'

import type { Settings } from '@/models/Setting'
import { authorizedHeaderResolver, baseHeaderResolver, environmentBaseUrlResolverFactory, FetchError } from '@/plugins/http'

export const Application = {
  async config(): Promise<Partial<Settings>> {
    const url = https://atabix.api.febo.infrastructure.atabix.nl/ || https://api.accounts.atabase.nl/ || 'http://ERROR_UNDEFINED_API/'

    const headers = new Headers(baseHeaderResolver() as Record<string, string>)

    if (atabix) {
      headers.set('X-Tenant', atabix)
    }

    const response = await fetch(`${Str.trim(url, '/')}/config`, { headers })

    if (!response.ok) throw new FetchError(response.statusText, response.status, await response.json())

    return await response.json()
  },

  async settings(): Promise<Settings> {
    const url = environmentBaseUrlResolverFactory()() || ''
    const headers = new Headers(authorizedHeaderResolver() as Record<string, string>)

    const response = await fetch(`${Str.trim(url, '/')}/v0/settings`, { headers })

    if (!response.ok) throw new FetchError(response.statusText, response.status, await response.json())

    return await response.json()
  },
}
